export async function initPlayer(hlsUrl, audio) {
  try {
    const mod = await import("hls.js");

    const Hls = mod.default ?? mod.Hls ?? mod;

    if (!Hls || typeof Hls !== "function") {
      console.error("Unexpected Hls export:", mod);
      return false;
    }

    if (typeof Hls.isSupported === "function" && Hls.isSupported()) {
      const hls = new Hls();

      hls.loadSource(hlsUrl);
      hls.attachMedia(audio);

      return true;
    } else {
      return false;
    }

  } catch (err) {
    return false;
  }
}
